import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
})
export class SearchFieldComponent {
  @Output() searchCriteria = new EventEmitter<String>();
  @Input() ID = 'search-field';
  searchWord: String | undefined;

  constructor() {}

  searchThis() {
    this.searchCriteria.emit(this.searchWord);
  }

  clear() {
    this.searchWord = '';
    this.searchCriteria.emit(this.searchWord);
  }
}
